import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";

const Content = ({ children }) => (
  <div id={"page-wrap"} className="Content">
    {children}
  </div>
);

Content.propTypes = {
  children: PropTypes.node
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/layout/Content.js